import React from "react";
import "./HistorySection.css";
import historyBg from "../../Assets/history-section-bg.png";

const HistorySection = () => {
  return (
    <section className="hs-wrapper">
      <img src={historyBg} alt="ADMK History" className="hs-bg-image" />
    </section>
  );
};

export default HistorySection;
